"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
//@ts-nocheck
const json_colorizer_1 = tslib_1.__importDefault(require("json-colorizer"));
function pretty(param, multiline = true, color = true) {
    if (typeof param === 'object') {
        const _res = color
            ? json_colorizer_1.default(JSON.stringify(param, null, multiline ? 2 : 0))
            : JSON.stringify(param, null, multiline ? 2 : 0);
        return _res;
    }
    return param;
}
exports.pretty = pretty;
//# sourceMappingURL=pretty.js.map